export const REALTIME_PATH = {
  users: {
    root: "users",
    path: "users/",
  },
  groups: {
    root: "hsna-groups",
    path: "hsna-groups/",
  },
  diary: {
    root: "diary",
    path: "diary/",
  },
  errorLog: {
    root: "log/errors",
    path: "log/errors/",
  },
  dataset: {
    root: "hsna-dataset",
    path: "hsna-dataset/",
  },
  modules: {
    root: "hsna-modules",
    path: "hsna-modules/",
  },
  email: {
    root: "email",
    path: "email/",
  },
  "s19003045@gmail.com": {},
};
